module.exports = __webpack_public_path__ + "images/emoji/rice_cracker.a651fbd9484d29849794.png";